import * as angular from "angular";
import { PrivacyNoticeDataProvider } from "../../data-provider/privacy-notice.dp";
import { ToastUtils } from "../../helper/toast.helper";
import { Utils } from "../../helper/utils.helper";
import { PrivacyNotice } from "../../models/privacy-notice.model";

let DeclinedPrivacyNoticeComponent = {
    selector: "vcDeclinedPrivacyNotice",
    templateUrl: "/angular/components/privacy/declined.component.html",
    bindings: {},
    controller: class DeclinedPrivacyNoticeController {
        public privacyNotice?: PrivacyNotice;
        public __env: any;
        private toast: ToastUtils;
        private utils: Utils;

        constructor(
            __env: any,
            ToastUtils: ToastUtils,
            Utils: Utils,
            PrivacyNoticeDataProvider: PrivacyNoticeDataProvider
        ) {
            this.__env = __env;
            this.toast = ToastUtils;
            this.utils = Utils;

            PrivacyNoticeDataProvider.pending().then(
                (privacyNotice?: PrivacyNotice) => {
                    this.privacyNotice = privacyNotice;
                }
            );
        }

        review(): void {
            if (!this.privacyNotice) this.toast.error();

            this.utils.acknowledgePrivacyNoticeDialog(this.privacyNotice);
        }
    },
};

angular
    .module("privacy", [
        "textAngular",
        "collectionpurpose",
        "campaign",
        "ngMaterial",
    ])
    .component(
        DeclinedPrivacyNoticeComponent.selector,
        DeclinedPrivacyNoticeComponent
    );
